export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";